<template>
    <a-layout class="layout" :class="[device]">
        <template>
            <a-drawer
                v-if="device === 'mobile'"
                :wrapClassName="'drawer-sider ' + navTheme"
                placement="left"
                @close="() => this.collapsed = false"
                :closable="false"
                :visible="collapsed"
                width="200px">
                <side-menu
                    mode="inline"
                    :menus="menus"
                    @menuSelect="menuSelect"
                    :theme="navTheme"
                    :collapsed="false"
                    :collapsible="true"></side-menu>
            </a-drawer>
        </template>
        <a-layout
            :class="[layoutMode, `content-width-${contentWidth}`]"
            :style="{ paddingLeft: fixSiderbar && isDesktop() ? `${sidebarOpened ? 200 : 80}px` : '0' }">
            <page-header
                :mode="layoutMode"
                :menus="menus"
                :theme="navTheme"
                :collapsed="collapsed"
                :device="device"
                :headerShowType="headerShowType"
                :moduleGroup="moduleGroup"
                @toggle="toggle"
                v-if="showHeader">
            </page-header>
            <route-view></route-view>

        </a-layout>
    </a-layout>
</template>

<script>

    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex';
    import RouteView from "@/components/layouts/RouteView";
    import { userLogout } from "@/api/api";
    import { postAction } from "@/api/api-manage";
    import { strIsEmpty, getAvatarPictureId, triggerWindowResizeEvent} from "@/utils/web-utils.js";
    import { mixin, mixinDevice } from '@/utils/mixin.js'
    import { Loading } from 'element-ui';
    import { USER_PHONE } from "@/store/mutation-types.js";
    import PageHeader from '@/components/layouts/PageHeader';
    import PageFooter from '@/components/layouts/PageFooter';
    import SideMenu from '@/components/menu/SideMenu';

    const indexKey = '/web/index';

    export default {
        name: "PageLayout",
        components: {
            PageHeader,
            PageFooter,
            SideMenu,
            RouteView
        },
        data() {
            return {
                collapsed: false,
                activeMenu:{},
                menus: [],
                reloadFlag:true,

                showHeader:true,
                showFooter: true,
                moduleGroup: 1,                         // 功能模块组别：1=后台，2=web
                headerShowType: 1,                      // 0=不显示， 1=有背景的， 2=没有背景的
            }
        },
        /** 子页面调用方法 */
        provide(){
            return{
                setHeaderShowType:this.setHeaderShowType,
                setHeaderIsShow:this.setHeaderIsShow,
                setFooterIsShow: this.setFooterIsShow,

                setCurrentNavMenu:this.setCurrentNavMenu,
                setLoading: this.setLoading
            }
        },
        watch: {
            '$route': function(newRoute) {
                if(newRoute != undefined && newRoute != null){
                    console.log('newRoute = ' + newRoute.fullPath);
                    // Web端一般都是单页
                    if (!this.multipage) {

                    }else if(indexKey == newRoute.fullPath) { // 【路由缓存】首页的缓存设置有问题，需要根据后台的路由配置来实现是否缓存
                        // web一般都是单页，一般不会执行这段代码
                        this.routeReload()
                    }
                }
            },
            sidebarOpened(val) {
                this.collapsed = !val
            }
        },
        computed: {
            ...mapState({
                // 主路由
                mainRouters: state => state.permission.addRouters,
                // 后台菜单
                permissionMenuList: state => state.user.permissionList
            }),
            multipage() {
                //判断如果是手机模式，自动切换为单页面模式
                if (this.isMobile()) {
                    return false
                } else {
                    return this.$store.state.app.multipage
                }
            }
        },
        mixins: [mixin, mixinDevice],
        methods: {
            ...mapActions(["userLogout", "setSidebar"]),
            // -------------------------------------------------------------------------------------- base start
            /** 初始化 */
            layoutInit:function () {
                this.menus = this.permissionMenuList;
                //console.log('PageLayout Init, menu = ' + JSON.stringify(this.menus));
            },
            /**  路由刷新 */
            routeReload(){
                this.reloadFlag = false
                let ToggleMultipage = "ToggleMultipage";
                this.$store.dispatch(ToggleMultipage,false)
                this.$nextTick(()=>{
                    this.$store.dispatch(ToggleMultipage,true)
                    this.reloadFlag = true
                })
            },
            // -------------------------------------------------------------------------------------- base end


            // -------------------------------------------------------------------------------------- public start
            // 设置顶栏显示方式( 0=不显示， 1=有背景的， 2=没有背景的)
            setHeaderShowType: function(showType, moduleGroupSet) {
                this.headerShowType = showType;
                if(moduleGroupSet != undefined){
                    this.moduleGroup = moduleGroupSet;
                }
            },
            /** 设置Header是否显示 */
            setHeaderIsShow: function(show){
                this.showHeader = show;
                //this.menus = this.permissionMenuList;
                //console.log('setHeaderIsShow, menu = ' + JSON.stringify(this.menus));
            },
            /**  设置Footer是否现实 */
            setFooterIsShow: function(show){
                this.showFooter = show;
            },
            // -------------------------------------------------------------------------------------- public end


            // -------------------------------------------------------------------------------------- 左栏菜单（mobile） start
            /**  菜单选择 */
            menuSelect() {
                if (!this.isDesktop()) {
                    this.collapsed = false
                }
            },
            // -------------------------------------------------------------------------------------- 左栏菜单（mobile） end


            toggle() {
                this.collapsed = !this.collapsed
                this.setSidebar(!this.collapsed)
                triggerWindowResizeEvent()
            },


            /** 设置当前菜单（子页面调用） */
            setCurrentNavMenu: function(menuIndex){
                this.dCurrentMenuIndex = menuIndex+'';
            },
            /** 菜单被选择处理函数 */
            menuSelected: function(key, keyPath){
                console.log('菜单选择 key = ' + key +  '  currentMenuIndex = ' + this.dCurrentMenuIndex);
                key = key-0;
                switch (key) {
                    case 1:
                        this.$router.push({name:"Index", query:{}});
                        break;
                }
            },
            /** 点击用户菜单处理函数 */
            handleUserMenuCommand: function(command){
                let that = this;
                //this.$message('click on item ' + command);
                command = command-0;
                switch (command) {
                    case 1:

                        break;
                    case 2:
                        this.logout();
                        break;
                }
            },
            /** 退出登陆 */
            logout: function(){
                let that = this;
                console.log('退出登陆');
                this.$confirm('你确认要退出吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    return that.userLogout({}).then(() => {
                        that.$router.push({ path: '/web/user/login' });
                    }).catch(err => {
                        that.$message.error(err.message);
                    });
                }).catch(() => {

                });
            },
            //--------------------------------------------- loading start
            setLoading: function(show, message){
                let that = this;
                this.dLoadingOptions.text = message;
                if(show){
                    if(!this.dLoadingInstance){
                        this.dLoadingInstance = Loading.service(this.dLoadingOptions);
                    }
                }else{
                    if(this.dLoadingInstance){
                        // 以服务的方式调用的 Loading 需要异步关闭
                        this.$nextTick(() => {
                            that.dLoadingInstance.close();
                        });
                    }
                }
            },
            //--------------------------------------------- loadding end
            /** 测试 */
            test:function () {
                //console.log('PageLayout test function call');
                //this.dCurrentMenuIndex = 2 + '';
            },


        },
        created:function(){
            console.log('layout created');
            this.layoutInit();
        },
    }
</script>






<style lang="less" scoped>

.page{
    width: 100%;
    height: 100vh;
    padding: 0px !important;
    display: block;
    //background-color: #00a0e9;

    .page-header{
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 40px !important;
        background-color: transparent !important;
        //background-color: #00ff80;
        border-bottom: 1px solid #eeeeee;
        z-index: 999;
        .page-header-bg {
            position: absolute;
            left: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            background-color: black;
            opacity: 0.1;
        }
        .page-header-logo {
            position: absolute;
            left: 8px;
            top: 5px;
            width: 30px;
            height: 30px;
            -moz-border-radius: 15px;
            -webkit-border-radius: 15px;
            border-radius: 15px;
        }
        .page-header-menu{
            position: absolute;
            left: 50px;
            right: 200px;
            padding-left: 40px;
            width: -webkit-calc(100% - 250px);
            width: -moz-calc(100% - 250px);
            width: calc(100% - 250px);
            height: 100%;
            //background-color: blue;
            .page-header-menu-item{
                height: 40px !important;
                line-height: 40px !important;
            }
        }
        .page-header-more{
            position: absolute;
            display: flex;
            justify-content: flex-end;
            right: 0px;
            width: 200px;
            height: 40px;
            line-height: 40px;
            .page-header-more-avatar{
                margin-top: 5px;
            }
            .page-header-more-menu{
                margin-left: 30px;
                margin-right: 30px;
                .page-header-more-menu-top{
                    height: 40px;
                    line-height: 40px;
                }
                .page-header-more-menu-item{

                }
            }
        }
    }
}

// drawer-sider 自定义(左边菜单)
.ant-drawer.drawer-sider {
    .sider {
        box-shadow: none;
    }
    &.dark {
        .ant-drawer-content {
            background-color: rgb(0, 21, 41);
        }
    }
    &.light {
        box-shadow: none;
        .ant-drawer-content {
            background-color: #fff;
        }
    }
    .ant-drawer-body {
        padding: 0
    }
}

</style>

<style lang="less">
    .centercontainer{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: column;
        .logo{
            width: 60px;
            height: 60px;
            margin-bottom: 30px;
        }
    }
</style>


